import React from 'react';
import styles from './LinksPanel.module.scss';
import { SFDrawer, SFIconButton } from 'sfui';
import { HeaderLink } from '../../../Models';

export interface LinksPanelProps {
  isOpen: boolean;
  links: HeaderLink[];
  onClose: () => void;
}

export const LinksPanel = ({
  isOpen,
  links,
  onClose
}: LinksPanelProps): React.ReactElement<LinksPanelProps> => {
  return (
    <SFDrawer
      anchor="right"
      PaperProps={{ className: styles.linksPanel }}
      open={isOpen}
      onClose={onClose}
    >
      <div className={styles.header}>
        <SFIconButton
          sfIcon="Close"
          sfSize="medium"
          onClick={onClose}
          aria-label="Close"
        />
      </div>

      <ul className={styles.links}>
        {links.map((link: HeaderLink) => (
          <li key={link.label} onClick={() => window.open(link.href, '_blank')}>
            {link.label}
          </li>
        ))}
      </ul>
    </SFDrawer>
  );
};
